import { Link } from "react-router-dom";
import type { StatusTone } from "../lib/overview-ops";
import { cmsStrings } from "../terminology";

type Props = {
  label: string;
  value: string | number;
  sublabel?: string;
  loading?: boolean;
  tone?: StatusTone;
  statusText?: string;
  to?: string;
  unavailable?: boolean;
};

const TONE_BADGE: Record<StatusTone, string> = {
  success: "state-badge--published",
  warning: "state-badge--paused",
  danger: "state-badge--emergency",
  info: "state-badge--scheduled",
  neutral: "state-badge--archived",
};

export function MetricCard({
  label,
  value,
  sublabel,
  loading,
  tone,
  statusText,
  to,
  unavailable,
}: Props) {
  const inner = (
    <>
      <p className="metric-card__label">{label}</p>
      {unavailable ? (
        <p className="metric-card__value metric-card__value--muted">
          {cmsStrings.shell.unavailable}
        </p>
      ) : (
        <p className="metric-card__value ltr-isolate latin-digits" dir="ltr" lang="en">
          {loading ? "…" : value}
        </p>
      )}
      {statusText && !unavailable && (
        <p className="metric-card__status">
          <span className={`state-badge ${TONE_BADGE[tone ?? "neutral"]}`}>{statusText}</span>
        </p>
      )}
      {sublabel && <p className="metric-card__sublabel">{sublabel}</p>}
    </>
  );

  if (to) {
    return (
      <Link to={to} className="metric-card metric-card--link" data-vt-metric-card>
        {inner}
      </Link>
    );
  }

  return (
    <article className="metric-card" data-vt-metric-card>
      {inner}
    </article>
  );
}
